import { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { useMap } from 'react-leaflet';
import { useMapActions } from '../../hooks/map/useMapActions';
import L from 'leaflet';
import {
    MAP_COLORS,
    MAP_SYMBOLS,
} from '../../utils/map/constants';

import { bindLegendEvents } from '../../utils/map/bindLegendEvents';

export default function MapLegend({
    plannedPolylineRef,
    realPolylineRef,
    modeMap
}) {
    
    const { blurPoint } = useMapActions();

    const map = useMap();
    const theme = useTheme();

    const backgroundColor = theme.palette.background.paper;

    const textColor = theme.palette.text.primary;

    useEffect(() => {

        const legend = L.control({
            position: 'topleft',
        });

        const isTripMode = modeMap === 'trip';

        legend.onAdd = () => {

            const div = L.DomUtil.create(
                'div',
                'map-legend'
            );

            div.innerHTML = `
                <div
                    style="
                        background:${backgroundColor};
                        color:${textColor};
                        padding:10px 12px;
                        border-radius:10px;
                        box-shadow:0 2px 8px rgba(0,0,0,.35);
                        display:flex;
                        align-items:center;
                        gap:8px;
                        font-size:14px;
                        font-weight:500;
                    "
                >

                    <div title="Ponto inicial">
                        ${MAP_SYMBOLS.startPoint} Início
                    </div>

                    <b>|</b>

                    <div title="Paradas">
                        ${MAP_SYMBOLS.point} Paradas
                    </div>

                    <b>|</b>

                    <div title="Ponto Final">
                        ${MAP_SYMBOLS.endPoint} Fim
                    </div>

                    <b>|</b>

                    <div
                        title="Percurso Previsto"
                        id="legend-planned"
                        style="
                            cursor:pointer;
                            display:flex;
                            align-items:center;
                            gap:8px;
                        "
                    >
                        <div
                            style="
                                width:28px;
                                height:5px;
                                border-radius:999px;
                                background:${MAP_COLORS.plannedRoute};
                            "
                        ></div>

                        <span>Previsto</span>
                    </div>

                    ${
                        isTripMode
                            ? `
                                <b>|</b>

                                <div
                                    title="Percurso Realizado"
                                    id="legend-real"
                                    style="
                                        cursor:pointer;
                                        display:flex;
                                        align-items:center;
                                        gap:8px;
                                    "
                                >
                                    <div
                                        style="
                                            width:28px;
                                            height:5px;
                                            border-radius:999px;
                                            background:${MAP_COLORS.realRoute};
                                        "
                                    ></div>

                                    <span>Realizado</span>
                                </div>
                            `
                            : ''
                    }

                </div>
            `;

            bindLegendEvents({
                map,
                element: div.querySelector('#legend-planned'),
                polylineRef: plannedPolylineRef,
                defaultWeight: 5,
                hoverWeight: 9,
                onFocus: blurPoint,
            });

            bindLegendEvents({
                map,
                element: div.querySelector('#legend-real'),
                polylineRef: realPolylineRef,
                defaultWeight: 9,
                hoverWeight: 12,
                onFocus: blurPoint,
            });

            return div;

        };

        legend.addTo(map);

        return () => legend.remove();

    }, [
        map,
        modeMap,
        backgroundColor,
        textColor,
        plannedPolylineRef,
        realPolylineRef,
        blurPoint
    ]);

    return null;

}